<template lang="pug">
  .task-coupon-container(
    :class="{'new-module': newModule && !preparing, 'new-style': newStyle}"
    :style="{paddingBottom: showMore? '0.06rem':''}"
  )
    template(v-if="tasks && tasks.length > 0")
      .tasks
        .task-item(v-for="(item, index) in tasks", :key="item.taskCode")
          template(v-if="item.shadow")
            .shadow-left
            .shadow-right
          template(v-else)
            .task-left.flex-mid
              .left.flex-mid
                template(v-if="newModule")
                  img.icon(
                    src="https://m.hellobike.com/resource/helloyun/15979/Qs28sb93gW.png"
                  )
                template(v-else)
                  .icon-block(v-if="!newStyle")
                    img.coin(
                      src="https://m.hellobike.com/resource/AppPlatformH5/fuli/McuKtqFNzr0bhHNNseHY8.png"
                    )
                    .amount.flex-mid
                      template(v-if="item.amount !== undefined")
                        span +
                        span.value {{ item.amount }}
                  .icon-new-block(v-else)
                    SafeImg(className="left-logo" :src="item.taskImgUrl")
              .mid
                template(v-if="newModule")
                  .top.flex-mid
                    .title {{ item.title }}
                    .icon-block.flex-mid
                      img.coin(
                        src="https://m.hellobike.com/resource/AppPlatformH5/fuli/McuKtqFNzr0bhHNNseHY8.png"
                      )
                      .amount
                        template(v-if="item.amount !== undefined")
                          span +
                          span.value {{ item.amount }}
                template(v-else)
                  .title {{ item.title }}
                template(v-if="!newStyle")
                  .progress(
                      v-if="item.status === TaskStatus.DOING || item.status === TaskStatus.CAN_DONE"
                    )
                    .progress-step
                      .progress-step-inner(
                        :style="{ width: (item.process / item.target) * 100 + '%' }"
                      )
                    .progress-text
                      span.colored {{ item.process }}
                      span /{{ item.target }}
                template(v-else)
                  .progress(v-if="item.amount")
                    .progress-left(v-if="item.status === TaskStatus.TO_ACCEPT") 完成后得奖励金
                    .progress-left(v-else) 完成后回来领
                    .progress-right
                      img.progress-right-img(:src="coinIcon")
                      .progress-right-text +{{item.amount}}
            .right.flex-mid
              .topIcon(
                v-if="getTaskMarkVisible(item)"
                :class="{ 'top-icon-doing': item.status === TaskStatus.DOING }"
                @click.stop="clickTaskV2(item, index)"
              )
                span.coupon-worth {{ item.couponInfo.worth || 0 }}
                span.coupon-unit 元券
              .btn.flex-mid(
                @click="clickTaskV2(item, index)",
                :class=`{
                    disabled: item.disabled,
                    'to-accept': item.status === TaskStatus.TO_ACCEPT,
                    doing: item.status === TaskStatus.DOING,
                    'can-done': item.status === TaskStatus.CAN_DONE
                  }`
              ) {{ item.buttonName }}
              .end(v-if="!newStyle") {{ item.end }}
      .more.flex-mid(
        v-if="!preparing && data && data.length > num && !showMore",
        @click="seeMore"
      )
        template(v-if="!showMore")
          span(v-if="newStyle") 还有{{taskNum}}个任务
          span(v-else) 查看更多任务
          .common-arrow-down
        template(v-else)
          span 收起
          .common-arrow-up
    template(v-else)
      Empty
  </template>

<script>
import { Native, env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import Empty from '@/components/empty';
import Toast from '@/components/toast';
import SafeImg from '@/components/safe-img';
import {
  getTokenAndKey,
  getCityInfo,
  getTokenAndLocation,
} from '@/utils/index';
import { mapTaskV2, mapBusinessInfo } from '@/utils/mappers';
import { TaskStatus } from '@/const/task';
import {
  acceptTaskV2,
  getTaskAward,
  receiveActivityCoupon,
} from '@/api/bounty';
import { getTaskActivity } from '@/api/fuli';
import { getVersion, getSystemCode } from '@/utils/systemCode';
import { jumpEvent } from '@/api/lottery';
import eventBus from '@/const/eventBus';
import { ParamsUtil } from '@/utils/params';
import {
  jumpUrl,
  compareVersions,
  checkWXInstallation,
  generateUUID,
} from '@/utils/tools';
import SPM from '../common/spm';
import {
  loadPlatformAds,
  showPlatformAds,
  pushNotificationEnabled,
  openSystemSettingPage,
  mobileAdReplacementWithLink,
  openDeepLinkWithParams,
  platformOpenScheme,
} from '../common/bridge';
import {
  processAdParams, pushTaskFinished, loadRewardResultPlatformAds, requestTaskMonitoring,
} from '../common/helper';
import {
  TrueJumpCrossTasks,
  ORDER_JUMP_CROSS,
  JUMP_TO_WX_RENT,
  WeiboBrowse,
  WhiteList,
  WELFARE_VERSION,
  SYSTEM_SETTING_TASKS,
  MARKET_PLAN,
  TASK_SPM_INFO_MAP,
} from '../consts';
import { handleMultiTraceTask } from '../common/task';

export default {
  name: 'BountyTaskCoupon',
  components: {
    Empty,
    SafeImg,
  },
  props: {
    newModule: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    preparing: {
      type: Boolean,
      default: true,
    },
    doubleInformation: {
      type: Object,
      default: () => ({}),
    },
    moduleKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      TaskStatus,
      btnText: {
        [TaskStatus.TO_ACCEPT]: '领任务',
        [TaskStatus.DOING]: '做任务',
        [TaskStatus.CAN_DONE]: '领奖励',
      },
      showMore: false,
      isMP: false,
      jumpTimer: null,
      rankedActivityList: [],
      doubleInformationHistory: null,
    };
  },
  inject: ['newTaskScene', 'taskScene'],
  computed: {
    newStyle() {
      return this.newTaskScene();
    },
    coinIcon() {
      return this.newStyle
        ? 'https://m.hellobike.com/resource/gallery/833/8TcECPUAyI.png'
        : 'https://m.hellobike.com/resource/gallery/407/5lCN0b95WJ.png';
    },
    tasks() {
      if (this.preparing) {
        return [{ shadow: true }, { shadow: true }, { shadow: true }];
      }
      if (!this.data || this.data.length === 0) {
        return [];
      }
      if (this.data.length <= 1 || this.showMore) {
        return this.data;
      }
      // app和小程序单独处理
      return this.data.slice(0, this.num);
    },
    num() {
      if (this.isMP) {
        if (!this.newModule) {
          return 1;
        }
      }
      return 2;
    },
    taskNum() {
      if (this.data.length && this.data.length > 2) {
        return this.data.length - 2 || 0;
      }
      return 0;
    },
  },
  watch: {
    tasks(v) {
      if (v && v.length > 0) {
        const taskCodes = v.map((item) => item.taskCode);
        if (taskCodes && taskCodes.length) {
          // this.getActivity(taskCodes);
        }
      }
    },
    doubleInformation: {
      handler(newVal) {
        // 由于用完后要置空 所以保存在data中
        this.doubleInformationHistory = { ...newVal };
      },
      deep: true,
    },
  },
  mounted() {
    if (env.isAliMP || env.isAliMPMonitor) {
      this.isMP = true;
    }
    this.clearnTimeOut();

    // 任务模块埋点上报
    const spmInfo = TASK_SPM_INFO_MAP[this.moduleKey] || {};
    if (spmInfo.moduleExpose) {
      SPM.moduleExpose({
        moduleId: spmInfo.moduleExpose,
        contentId: spmInfo.moduleExpose,
        businessInfo: {},
      });
    }
  },
  beforeDestroy() {
    this.jumpTimer = null;
  },
  methods: {
    async getActivity(taskCodes) {
      if (!this.newStyle) return;
      try {
        const { token, adCode, cityCode } = await getTokenAndLocation();
        const params = {
          token,
          adCode,
          cityCode,
          taskCodes,
        };
        const {
          data: { taskCouponList = [] },
        } = await getTaskActivity(params);
        if (!taskCouponList || !taskCouponList.length) return;
        const rankedActivityList = this.tasks.map((task) => {
          const activity = taskCouponList.find(
            (act) => act.taskCode === task.taskCode,
          );
          if (
            activity
            && activity.couponInfo
            && activity.couponInfo.prizeDesc
          ) {
            const { couponInfo } = activity;
            const subCoupon = {
              ...couponInfo,
            };
            return subCoupon;
          }
          return {};
        });
        this.rankedActivityList = rankedActivityList;
      } catch {
        //
      }
    },
    async receiveActivity(activity) {
      const {
        activityCode, prizeCode, status, eventCode,
      } = activity;
      if (status !== 1) {
        // 活动不是可领状态
        return;
      }
      const { token, adCode, cityCode } = await getTokenAndLocation();
      const param = {
        token,
        adCode,
        cityCode,
        activityCode,
        eventCode,
        param: {
          activityCode,
          prizeCode,
        },
        department: 'platform',
        channelId: env.platformCode,
        // channelId: 4,
      };

      receiveActivityCoupon(param)
        .then(() => {
          // if (env.isEasyBikeApp) {
          //   this.$emit('coupon');
          // }
          // Toast.show('领取成功')
          this.getActivity();
        })
        .catch(() => {
          Toast.show('领取失败');
        });
    },
    seeMore() {
      const spmInfo = TASK_SPM_INFO_MAP[this.moduleKey] || {};
      SPM.clickButton({
        buttonName: spmInfo.moreBtnClick,
        businessInfo: {},
      });
      // 展开之后不需要收起按钮，会影响屏效
      this.showMore = !this.showMore;
    },
    async handleDoingTask(item) {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'market_task_clicktodo',
        categoryId: 'market',
        businessInfo: mapBusinessInfo(item),
      });

      // 如果是商业化任务 并且是新版本 并且是多链接跳转形式 调用统一bridge处理
      if (item.businessType === 'commercial'
        && await getVersion() >= '6.98.50'
        && item.linkingMode === 3
      ) {
        const { userNewId } = await getTokenAndKey();
        const { app } = item.btnLink;
        const {
          jumpPattern,
          iosAppId = '',
          androidPkgName = '',
          wakePortLink = '',
          link = '',
          userName = '',
          path = '',
          // impressionTracking = '',
          ulk,
          clickTracking = '',
        } = app;
        try {
          Native.callNative({
            classMap: 'hellobike/marketing/openAllAdsURLAndTrack',
            method: 'openAdsUrlWithTracking',
            params: {
              // "applet" : 微信小程序 "deeplink" : deeplink 唤端
              linkType: jumpPattern === 1 ? 'applet' : 'deeplink',
              jumpConfig: {
                iosAppId, // iOS跳转AppStore应用id
                androidPkgName, // 安卓应用包名
                userName, // 微信小程序 username
                path, // 微信小程序 path
                wakePortLink, // deeplink 唤端
                link, // 兜底链接
                ulk, // ulink
              },
              trackConfig: {
                userId: userNewId,
                taskCode: item.taskCode,
                trackerUrls: [
                  {
                    trackerUrl: clickTracking,
                    requestType: 'get',
                  },
                ],
              },
              // 6.98.70商业化客户端，针对愉悦赚任务新增的参数appendConfig
              // 用于URL参数替换。替换参数后会给跳转的页面带上参数。用于绑定哈啰用户和第三方页面的任务状态关系。
              appendConfig: [
                {
                  replaceKey: '__USER_NEW_ID__',
                  appendKey: 'userId',
                  value: userNewId,
                },
                {
                  replaceKey: '__TASK_CODE__',
                  appendKey: 'taskCode',
                  value: item.taskCode,
                },
              ],
              uuid: generateUUID(),
            },
          });
        } catch (e) {
          Toast.show(e && e.message ? e.message : '网络开小差~');
        }
        return;
      }

      // 商业方案为pp_effct_adtask的时候，需要对h5链接的参数做替换和加参处理
      // 不能走通用换端的native，需要前端手动上报h5链接
      if (item.marketPlan === MARKET_PLAN.PP_EFFECT_ADTASK) {
        const { app } = item.btnLink;
        const { schema, h5 } = app;
        if (h5) {
          const newLink = await this.taskLinkParamsHandle(h5, item);
          // h5链接上报
          await requestTaskMonitoring(newLink, item);
        }
        if (schema) {
          const httpsRegex = /^https?:\/\/\S+/;
          const newLink = await this.taskLinkParamsHandle(schema, item);
          // 如果是http开头的链接，则跳转三方h5，否则打开调用native打开deepLink
          if (httpsRegex.test(schema)) {
            Native.openThirdWeb({ url: newLink });
          } else {
            openDeepLinkWithParams({ wakeLink: newLink });
          }
        }
        return;
      }

      // 跳转系统设置页
      if (SYSTEM_SETTING_TASKS.includes(item.marketPlan)) {
        openSystemSettingPage();
        return;
      }

      if (item.linkingMode === 3) {
        handleMultiTraceTask(item);
        return;
      }

      const matchPlan = [
        ...TrueJumpCrossTasks,
        ...WeiboBrowse].includes(item.marketPlan);
      if (item.taskActivityType === 1 && !matchPlan) {
        let channel = 'app';
        if (env.isAliMP || env.isAliMPMonitor) {
          channel = 'ali';
        }
        const data = await getTokenAndLocation();
        const { token, adCode, cityCode } = data;
        try {
          let btnLink = item.btnLink[channel];
          if (ORDER_JUMP_CROSS.includes(item.marketPlan)) {
            btnLink = item.btnLink[channel].schema;
          }
          const res = await jumpEvent({
            token,
            cityCode, // 021
            adCode, // '310112'
            channelId: env.platformCode,
            systemCode: getSystemCode(),
            version: await getVersion(),
            btnLink,
            taskCode: item.taskCode,
            sceneNameEn: 'weekly_cash',
            subSceneNameEn: 'weekly_cash_app',
            browseDuration: item.browseDuration,
          });
          if (res.success) {
            const link = item.btnLink[channel] || item.titleBarUrl;
            if (channel === 'ali') {
              Native.callNative({
                method: 'goOperationUrlV2',
                params: link,
              });
            } else {
              window.onpageshow = null;
              // eslint-disable-next-line no-unused-vars
              window.onpageshow = (event) => {
                window.location.reload();
              };
              if (ORDER_JUMP_CROSS.includes(item.marketPlan)) {
                if (env.isIOS) {
                  if ((await getVersion()) >= '6.72.0') {
                    platformOpenScheme(link);
                  } else if (
                    WhiteList.filter(
                      (whiteItem) => link.schema && link.schema.includes(whiteItem),
                    ).length > 0
                  ) {
                    window.location.href = link.schema;
                    this.jumpTimer = setTimeout(() => {
                      Native.openThirdWeb({ url: link.h5 });
                    }, 3000);
                  } else {
                    Native.openThirdWeb({ url: link.h5 });
                  }
                } else if (env.isAndroid) {
                  if ((await getVersion()) >= '6.70.0') {
                    platformOpenScheme(link);
                  } else {
                    Native.openThirdWeb({ url: link.h5 });
                  }
                }
                return;
              }
              // 跳转微信拦截处理
              if (env.isEasyBikeApp && env.isIOS && JUMP_TO_WX_RENT.includes(item.marketPlan)) {
                const isWXInstalled = await checkWXInstallation();
                if (!isWXInstalled) {
                  Toast.show('请先安装微信');
                  return;
                }
              }
              jumpUrl(link);
            }
          }
        } catch (e) {
          Toast.show(e && e.message ? e.message : '任务领取失败');
        }
      } else {
        let channel = 'app';
        if (env.isAliMP || env.isAliMPMonitor) {
          channel = 'ali';
        }
        const link = item.btnLink[channel] || item.titleBarUrl;
        if (channel === 'ali') {
          Native.callNative({
            method: 'goOperationUrlV2',
            params: link,
          });
        } else if (item.taskActivityType === 8) {
          window.location.href = link;
        } else if (item.marketPlan === 'weibo_browse') {
          Native.openThirdWeb({ url: link });
        } else if (TrueJumpCrossTasks.includes(item.marketPlan)) {
          if (env.isIOS) {
            if ((await getVersion()) >= '6.72.0') {
              platformOpenScheme(link);
            } else if (
              WhiteList.filter(
                (whiteItem) => link.schema && link.schema.includes(whiteItem),
              ).length > 0
            ) {
              window.location.href = link.schema;
              this.jumpTimer = setTimeout(() => {
                Native.openThirdWeb({ url: link.h5 });
              }, 3000);
            } else {
              Native.openThirdWeb({ url: link.h5 });
            }
          } else if (env.isAndroid) {
            if ((await getVersion()) >= '6.70.0') {
              platformOpenScheme(link);
            } else {
              Native.openThirdWeb({ url: link.h5 });
            }
          }
        } else {
          jumpUrl(link);
        }
      }
    },
    async clickTaskV2(item, index) {
      if (!item || item.disabled) {
        return;
      }
      if (item.status === TaskStatus.DOING) {
        this.close();
      }

      let UBTButtonName = 'market_task_clickreceive';
      if (item.status === TaskStatus.DOING) {
        UBTButtonName = 'market_task_clicktodo';
      } else if (item.status === TaskStatus.CAN_DONE) {
        UBTButtonName = 'market_task_getrewards';
      }
      UBT.clickButton({
        pageId: 'platform_bounty',
        buttonName: UBTButtonName,
        categoryId: 'platform',
        businessInfo: mapBusinessInfo(item),
      });

      // 惊喜任务点击埋点
      if (this.moduleKey === 'welfare_surprise_tasks') {
        let channel = 'app';
        if (env.isAliMP || env.isAliMPMonitor) {
          channel = 'ali';
        }
        const clkUrl = (item.btnLink && item.btnLink[channel]) || item.titleBarUrl || '';
        UBT.clickButton({
          pageId: 'Welfare',
          buttonName: 'platform_Welfare_superStarTask',
          categoryId: 'platform',
          businessInfo: {
            clk_url: clkUrl,
            btn_name: item.buttonName || '',
            task_status: item.taskStatus || '',
            adsource: ParamsUtil.getParams().adsource || '',
            taskname: item.taskName || item.title || '',
            taskId: item.taskCode || '',
          },
        });
      }

      // 任务点击埋点上报
      const spmInfo = TASK_SPM_INFO_MAP[this.moduleKey] || {};
      SPM.clickButton({
        buttonName: spmInfo.btnClick,
        businessInfo: {
          task_id: item.taskCode,
          task_name: item.taskName,
        },
      });

      // eslint-disable-next-line no-console
      if (item.shouldAccept) {
        const { token } = await getTokenAndKey();
        UBT.clickButton({
          pageId: 'Welfare',
          buttonName: 'market_task_clickreceive',
          categoryId: 'market',
          businessInfo: mapBusinessInfo(item),
        });
        const { taskGroupCode, taskCode, expertId } = item;
        acceptTaskV2({
          token,
          channelId: env.platformCode,
          sceneNameEn: 'platform_points',
          subSceneNameEn: 'platform_points_pointshp',
          version: await getVersion(),
          ...(await getCityInfo()),
          taskList: [
            {
              taskCode,
              taskGroupCode,
              expertId,
            },
          ],
        })
          .then((res) => {
            if (this.newStyle && item.couponInfo && item.couponInfo.worth) {
              this.receiveActivity(item.couponInfo);
            }
            if (res && res.data && res.data.taskList && res.data.taskList[0]) {
              const { errorCode } = res.data.taskList[0] || {};
              if (errorCode) return;

              Toast.show('任务领取成功');
              const task = mapTaskV2(res.data.taskList[0]);
              const {
                status,
                process,
                target,
                shouldAccept,
                buttonName,
                end,
              } = task;
              Object.assign(this.data[index], {
                status,
                process,
                target,
                shouldAccept,
                buttonName,
                end,
              });

              // 处理消息推送类任务自动完成
              this.handlePushTaskFinished(item);
              this.handleDoingTask(item);
            } else {
              Toast.show('查询任务信息失败');
              Object.assign(this.data[index], {
                status: TaskStatus.DOING,
                buttonName: this.btnText[TaskStatus.DOING],
                shouldAccept: false,
              });
            }
          })
          .catch((e) => {
            Toast.show(e && e.message ? e.message : '任务领取失败');
          });
      } else {
        if (item.status === TaskStatus.CAN_DONE) {
          const { token } = await getTokenAndKey();
          UBT.clickButton({
            pageId: 'Welfare',
            buttonName: 'market_task_getrewards',
            categoryId: 'market',
            businessInfo: mapBusinessInfo(item),
          });
          const { taskGuid, taskGroupCode } = item;
          getTaskAward({
            token,
            channelId: env.platformCode,
            taskGuid,
            taskGroupCode,
            version: await getVersion(),
          })
            .then(() => {
              Toast.show(`任务奖励领取成功，+${item.amount}奖励金`);
              Object.assign(this.data[index], {
                buttonName: '已领取',
                disabled: true,
              });
              if (env.isEasyBikeApp) {
                // 加载任务奖励领取弹窗
                this.handleLoadTaskAwardPopup({
                  rewardCount: item.amount,
                });
              }
            })
            .catch((e) => {
              Toast.show(`${(e && e.message) || '任务奖励领取失败'}`);
            });
          return;
        }
        if (item.status === TaskStatus.DOING) {
          this.handleDoingTask(item);
        }
      }
    },
    /**
     * 任务链接参数处理
     * @param {string} link - h5链接
     * @param {object} task - task任务数据
     * @returns {Promise<string>} 处理后的链接
     */
    async taskLinkParamsHandle(link, task) {
      try {
        const res = await mobileAdReplacementWithLink({ link });
        const { userNewId } = await getTokenAndKey();
        const resLink = ParamsUtil.addParams(res.link, {
          userid: userNewId,
          taskCode: task.taskCode,
        }).replace('__REQUESTID__', generateUUID()).replace('__TASK_CODE__', task.taskCode).replace('__USER_NEW_ID__', userNewId);
        return resLink;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('任务链接参数处理失败', error);
        return link;
      }
    },

    close() {
      this.$emit('close');
    },
    clearnTimeOut() {
      const clearnTimeOut = () => {
        if (this.jumpTimer) {
          clearTimeout(this.jumpTimer);
        }
      };
      document.addEventListener('visibilitychange', () => {
        if (document.hidden || document.webkitHidden) {
          clearnTimeOut();
        }
      });
      window.addEventListener('pagehide', () => {
        clearnTimeOut();
      });
    },
    // 处理任务领奖弹窗加载
    async handleLoadTaskAwardPopup(options) {
      const { rewardCount } = options || {};
      const taskScene = this.taskScene();

      // 非新版V2场景，不走后续逻辑
      if (taskScene !== WELFARE_VERSION.NEW_TASK_SCENE_V2) {
        eventBus.$emit('playCollectAnimate');
        return;
      }
      // 加载弹窗
      const adsInfo = processAdParams(this.doubleInformationHistory || {});
      const loadRes = await loadPlatformAds({
        pageName: 'rewardResult',
        timeout: '2',
        // 是否展示广告（本期不做）
        scene: 'rebateBonus',
        adsource: ParamsUtil.getParams().adsource || '',
        adsInfo,
        otherInfo: {
          data: { rewardCount },
        },
      });
      const { bannerTaskRelationCouponInfo } = this.doubleInformationHistory || {};
      this.doubleInformationHistory = null;

      if (loadRes && loadRes.pageId) {
        // 播放金币收起动画
        eventBus.$emit('playCollectAnimate');
        // 任务完成弹窗曝光埋点
        SPM.moduleExpose({
          moduleId: 'Welfare_taskcompop',
          contentId: 'Welfare_taskcompop',
          businessInfo: {
            adv: adsInfo.adUnitId && adsInfo.rewardCount ? '0' : '1',
          },
        });
        // 展示弹窗
        const showRes = await showPlatformAds({
          pageId: loadRes.pageId,
        });
        const { action, inspireType, adsInfo: { rewardTotalCount = '' } = {} } = showRes || {};
        switch (action) {
          // 签到翻倍
          case 'bannerReward':
            loadRewardResultPlatformAds({
              inspireType,
              bannerTaskRelationCouponInfo,
              otherInfo: {
                data: {
                  rewardCount: rewardTotalCount,
                },
              },
            });
            SPM.clickButton({
              buttonName: 'Welfare_taskcompop_adv',
              businessInfo: {},
            });
            break;
          case 'close':
            SPM.clickButton({
              buttonName: 'Welfare_taskcompop_close',
              businessInfo: {},
            });
            break;
          default:
            break;
        }
      }
    },
    // 处理任务自动完成
    async handlePushTaskFinished(task) {
      const { marketPlan } = task || {};
      const version = await getVersion();

      if (
        marketPlan === 'remind'
        && compareVersions(version, '6.89.5') !== -1
      ) {
        const { enabled = false } = await pushNotificationEnabled();
        if (enabled) {
          const result = await pushTaskFinished(task);
          if (!result.success) return;
          this.$emit('refreshTasks');
        }
      }
    },
    // 判断任务角标展示逻辑
    getTaskMarkVisible(item) {
      return (
        this.newStyle
        && item.couponInfo
        && item.couponInfo.worth
        && item.status !== TaskStatus.CAN_DONE
        && !item.disabled
      );
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.task-coupon-container {
  width: 100%;

  .more {
    font-size: 0.12rem;
    color: #5a6066;
    margin-top: 0.15rem;
    font-family: PingFang SC, sans-serif;

    * {
      border-color: #999 !important;
    }
  }

  .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.12rem;
    color: #ccc;
    padding-bottom: 0.2rem;

    img {
      width: 0.78rem;
      height: 0.68rem;
      margin-bottom: 0.08rem;
    }
  }

  .shadow-left {
    width: 0.44rem;
    height: 0.45rem;
    background: #f7f9fa;
    border-radius: 0.04rem;
  }

  .shadow-right {
    width: 2.64rem;
    height: 0.33rem;
    background: #f7f9fa;
    border-radius: 0.04rem;
  }

  .progress-right {
    padding-right: 0.08rem !important;
  }

  .progress-right-img {
    width: 0.16rem !important;
    height: 0.16rem !important;
  }

  .progress-right-text {
    margin-left: 0.02rem;
    line-height: normal;
    transform: translateY(-0.01rem);
  }

  .task-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 100%;
    align-items: center;
    position: relative;

    &:not(:first-of-type) {
      margin-top: 0.12rem;
    }

    .left {
      display: flex;
      flex-direction: column;
      margin-right: 0.08rem;

      .icon-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 0.44rem;
        height: 0.46rem;
        background: rgba(254, 244, 231, 0.71);
        border-radius: 0.06rem;
        padding-top: 0.06rem;
        padding-bottom: 0.03rem;

        .coin {
          width: 0.22rem;
          height: 0.22rem;
        }

        .amount {
          font-size: 0.12rem;
          font-weight: bold;
          color: #fb990f;

          .value {
            font-family: 'DIN Alternate Bold', sans-serif;
          }
        }
      }
    }

    .mid {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      flex: 1;
      max-width: 1.9rem;
      overflow: hidden;
      align-items: flex-start;

      .title {
        max-width: 1.9rem;
        font-size: 0.14rem;
        line-height: 0.16rem;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 0.04rem;
      }

      .progress {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .progress-step {
          display: flex;
          justify-content: flex-start;
          width: 1rem;
          height: 0.04rem;
          background: rgba(238, 238, 238, 1);
          border-radius: 0.02rem;
          overflow: hidden;
          position: relative;

          .progress-step-inner {
            background: rgba(255, 211, 91, 1);
            height: 100%;
            border-radius: 0.02rem;
          }
        }

        .progress-text {
          display: flex;
          font-size: 0.1rem;
          margin-left: 0.08rem;
          color: rgba(153, 153, 153, 1);
          letter-spacing: 1px;

          .colored {
            color: rgba(255, 165, 38, 1);
          }
        }

        .progress-left {
          color: #999;
          font-size: 0.12rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        }

        .progress-right {
          display: flex;
          height: 0.17rem;
          line-height: 0.17rem;
          padding-right: 0.04rem;
          margin-left: 0.04rem;
          background-color: #fff8da;
          border-radius: 0.16rem;
        }

        .progress-right-img {
          width: 0.17rem;
          height: 0.17rem;
        }

        .progress-right-text {
          color: #ff3e36;
          font-weight: 700;
          font-size: 0.12rem;
          font-family: 'DIN Alternate Bold', sans-serif;
        }
      }
    }

    .right {
      flex-direction: column;
      align-items: flex-end;

      .end {
        font-size: 0.1rem;
        color: #999;
        margin-top: 0.04rem;
        white-space: nowrap;
      }

      .btn {
        width: 0.63rem;
        height: 0.24rem;
        line-height: 0.24rem;
        font-size: 0.12rem;
        font-weight: 500;
        border-radius: 0.32rem;

        &.disabled {
          background: #f0f3f5 !important;
          color: #bcc4cc !important;
        }

        &.to-accept {
          background: #ffeee9;
          color: #ff5526;
        }

        &.doing {
          border: 1px solid #ff5526;
          color: #ff5526;
        }

        &.can-done {
          background: #ff5c0a;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }

  &.new-module {
    margin-bottom: 0.1rem;

    .icon {
      max-height: 0.34rem;
      max-width: 0.34rem;
    }

    .task-item {
      align-items: center;

      &:not(:first-of-type) {
        padding-top: 0.13rem;
        border-top: 0.01rem solid #f7f9fa;
      }

      .left {
        margin-right: 0.08rem;
      }

      .mid {
        .progress {
          .progress-step {
            background: #ffccbd;
            border-radius: 0.03rem;

            .progress-step-inner {
              background: #ff5526;
              border-radius: 0.04rem;
            }
          }

          .progress-text {
            line-height: 0.12rem;

            .colored {
              color: #ff5526;
            }
          }
        }

        .top {
          align-items: start;

          .title {
            max-width: 1.38rem;
            margin-bottom: 0.08rem;
            color: #242729;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .icon-block {
            max-width: 0.43rem;
            max-height: 0.16rem;
            border-radius: 0.09rem;
            border: 0.01rem solid #ffc86a;
            margin: 0 0 0.06rem 0.08rem;

            .coin {
              max-width: 0.16rem;
              max-height: 0.16rem;
            }

            .amount {
              line-height: 0.1rem;
              font-weight: 500;
              font-size: 0.1rem;
              color: #ee8c02;
              margin: 0 0.07rem 0 0.02rem;
              position: relative;
              bottom: 0.01rem;

              .value {
                position: relative;
                bottom: -0.01rem;
              }
            }
          }
        }
      }

      .right {
        .btn {
          &.to-accept {
            border: 0.01rem solid #ff5526;
            background: transparent;
          }
        }
      }
    }
  }

  &.new-style {
    padding: 0 0.02rem;

    .more {
      margin: 0.13rem auto 0 auto;
      color: #5a6066;
      border-radius: 0.32rem;
      width: 1.43rem;
      height: 0.26rem;
      line-height: 0.26rem;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;

      * {
        border-color: #999 !important;
      }
    }

    .tasks {
      .task-item {
        align-items: center;

        .task-left {
          .left {
            align-self: flex-start;

            .icon-block {
              .amount {
                font-family: DIN Alternate, sans-serif;
                font-weight: 700;
                color: #92681f;
              }
            }

            .icon-new-block {
              overflow: hidden;
              width: 0.42rem;
              height: 0.42rem;
              border-radius: 0.12rem;
            }
          }
        }

        .right {
          position: relative;

          .topIcon {
            position: absolute;
            top: -0.14rem;
            padding-top: 0.03rem;
            right: 0;
            width: 0.38rem;
            height: 0.26rem;
            background-image: url('https://m.hellobike.com/resource/gallery/833/_shGsGqPzO.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            font-weight: 600;
            color: #fff;
            font-size: 0.08rem;
            text-align: center;

            &.top-icon-doing {
              top: -0.12rem;
              background-image: url('https://m.hellobike.com/resource/gallery/833/ZwGNPEkTHK.png');
            }
          }

          .coupon-worth {
            font-family: 'DIN Alternate Bold', sans-serif;
            font-size: 0.11rem;
          }

          .coupon-unit {
            position: relative;
            top: -0.01rem;
          }

          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 0.63rem;
            height: 0.24rem;
            line-height: normal;
            font-size: 0.12rem;
            font-weight: 500;
            border-radius: 0.32rem;

            &.disabled {
              background: #f0f3f5 !important;
              color: #bcc4cc !important;
            }

            &.to-accept {
              background: #ff5526;
              color: #fff;
            }

            &.doing {
              color: #ff5526;
              border: 1px solid #ff5c0a;
            }

            &.done {
              color: #fff;
              background-color: #bcc4cc;
            }

            &.can-done {
              background: #ffd764;
              color: #643b00;
            }
          }
        }
      }
    }
  }
}
</style>
